import { render } from "./PropsCard.vue?vue&type=template&id=2a8476f7"
import script from "./PropsCard.vue?vue&type=script&lang=js"
export * from "./PropsCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__